module.exports = __webpack_public_path__ + "static/media/kuslers_logo.66883c02.png";